export default __webpack_public_path__ + "static/media/the-dancing-one.cfd777fd.png";